module.exports = __webpack_public_path__ + "static/media/time_series_analyzer.0141ac4c.png";